import { makeStyles } from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '320px',
    maxWidth: '975px',
    padding: '0 20px',
    margin: '8% auto',
    boxSizing: 'border-box',
    '@media (max-width: 920px)': {
      flexDirection: 'column',
      height: '100%'
    }
  },
  imageContainer: {
    position: 'relative',
    zIndex: 0,
    marginRight: '70px',
    width: '50%',
    '@media (max-width: 1024px)': {
      marginRight: '40px'
    },
    '@media (max-width: 920px)': {
      width: '100%',
      maxWidth: '460px',
      margin: '40px auto 0',
      height: '320px',
    },
    '@media (max-width: 576px)': {
      height: '250px'
    }
  },
  imageFront: {
    position: 'absolute',
    width: '62%',
    boxShadow: '10px 10px 20px rgb(0 0 0 / 20%)',
    top: '0',
    left: '0',
    height: 'auto',
    maxWidth: '100%',
    '@media (max-width: 576px)': {
      width: '100%',
      maxWidth: '200px'
    }
  },
  imageBack: {
    position: 'absolute',
    width: '62%',
    boxShadow: '10px 10px 20px rgb(0 0 0 / 20%)',
    bottom: 0,
    right: 0,
    zIndex: -1,
    height: 'auto',
    maxWidth: '100%',
    '@media (max-width: 576px)': {
      width: '100%',
      maxWidth: '200px'
    }
  },
  contentContainer: {
    position: 'relative',
    zIndex: 0,
    width: '50%',
    '@media (max-width: 920px)': {
      width: '100%',
      maxWidth: '460px',
      margin: '40px auto 0',
      height: '320px',
    }
  },
  contentMask: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: '10px',
    marginTop: '33px',
    marginLeft: '33px',
    zIndex: -1,
    borderWidth: '10px',
    borderStyle: 'solid',
    borderColor: 'rgba(202, 164, 137, 0.3)',
  },
  content: {
    background: '#333',
    color: '#fff',
    fontSize: '24px',
    fontStyle: 'italic',
    position: 'absolute',
    left: '0',
    right: '0',
    top: '10px',
    bottom: '0',
    marginBottom: '43px',
    marginRight: '33px',
    lineHeight: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '0',
    '& span': {
      width: '75%'
    },
    '@media (max-width: 920px)': {
      fontSize: '20px'
    },
    '@media (max-width: 670px)': {
      fontSize: '16px'
    },
    '@media (max-width: 520px)': {
      fontSize: '12px'
    }
  }
}));
